import React from 'react';
import { Item } from './style';
import { resolveImagePath } from '../../util';
import { Heading, Text, FlexCol } from '../misc';

const SummaryItem = ({ articleID, brand, qty, price }) => (
  <Item>
    <Item.Image src={resolveImagePath(articleID)} />
    <FlexCol>
      <Heading>{articleID}</Heading>
      <Text>{brand}</Text>
    </FlexCol>
    <Item.Price>
      <Text>
        {qty} x {price}
      </Text>
    </Item.Price>
  </Item>
);

export default SummaryItem;



// WEBPACK FOOTER //
// ./src/components/summary/summaryItem.js